/**
 * Boards selectors
 */

import { RootState } from "types";

import { createSelector } from "@reduxjs/toolkit";

import { initialState } from "app/components/Sidebar/components/Favorite/Redux/initialState";

const selectDomain = (state: RootState) => state.favoriteState || initialState;

export const selectFavorites = createSelector(
  [selectDomain],
  (state) => state.favorites,
);

export const selectError = createSelector(
  [selectDomain],
  (state) => state.error,
);

export const selectLoading = createSelector(
  [selectDomain],
  (state) => state.loading,
);

export const selectIsSearching = createSelector(
  [selectDomain],
  (state) => state.isSearching,
);

export const selectSearchValue = createSelector(
  [selectDomain],
  (state) => state.searchValue,
);

export const selectOpenModalId = createSelector(
  [selectDomain],
  (state) => state.openModalId,
);

export const selectPagination = createSelector([selectDomain], (state) => {
  return state.pagination;
});

export const selectHasMore = createSelector([selectDomain], (state) => {
  return state.pagination.page < state.pagination.totalPage;
});

export const selectUpdateFavoriteLoading = createSelector(
  [selectDomain],
  (state) => state?.updateFavoriteLoading,
);
